import { mapState, mapGetters } from 'vuex';
import {
  faText,
  faFaceViewfinder,
  faEraser,
  faBrush,
  faImages,
  faPhotoVideo,
  faWaveform,
  faBriefcase,
} from '@fortawesome/pro-regular-svg-icons';
import { faClapperboardPlay, faImage, faWaveformLines } from '@fortawesome/pro-solid-svg-icons';
import { aiToolsIds } from '@motionelements/core/src/helpers/ai-tools.js';

export default {
  name: 'AiToolsMixin',
  data() {
    return {
      icons: {
        background_remover: faEraser,
        face_swap: faFaceViewfinder,
        image_to_video: faPhotoVideo,
        image_variations: faImages,
        music_duration: faWaveform,
        style_transfer: faBrush,
        video_scriptwriter: faText,
        video_upscaler: faClapperboardPlay,
        text_to_illustration: faBriefcase,
      },
    };
  },
  computed: {
    ...mapState({
      aiToolsList: state => state.aiTools.list,
      internalTools: state => state.aiTools.internalTools,
    }),
    ...mapGetters({
      aiToolsReleased: 'aiTools/aiToolsReleased',
    }),
    aiToolsIds() {
      return aiToolsIds;
    },
    aiTools() {
      return this.aiToolsReleased
        .map(tool => ({
          ...tool,
          icon: this.icons[tool.id],
        }));
    },
    aiToolsMaintained() {
      return this.aiToolsList
        .filter(({ maintained }) => maintained);
    },
    aiToolsGrouped() {
      const aiToolsGrouped = [
        {
          id: 'video',
          title: this.$t('term.video'),
          icon: faClapperboardPlay,
        },
        {
          id: 'image',
          title: this.$t('term.image'),
          icon: faImage,
        },
        {
          id: 'audio',
          title: this.$t('term.audio'),
          icon: faWaveformLines,
        },
      ];
      return aiToolsGrouped.map(group => ({
        ...group,
        scrollId: `media-type-${group.id}`,
        tools: this.aiTools.filter(aiTool => aiTool.mediaType === group.id),
      }));
    },
    comingSoonAiTools() {
      return this.aiToolsList
        .filter(({ released }) => !released);
    },
  },
  methods: {
    handleAiToolLink(toolLink, toolId) {
      if (!this.internalTools.includes(toolId)) {
        window.location.href = this.$link(toolLink).aiUrl();
      } else {
        this.$router.push(this.$link(toolLink).fullPath());
      }
    },
  },
};
